module.exports = __webpack_public_path__ + "media/images/waiterIcon-978f75f2.svg";